import { useBottomControlsSectionCollapse } from "@rentablo/components";
import { SelectComparison } from "../../BaseChartTools";
import { canShowComparison, useChartControls } from "../ChartControlsContext";

interface Props {
  fullWidth?: boolean;
}

export const ComparisonControl = ({ fullWidth = false }: Props) => {
  const ctx = useChartControls();
  const { comparedTicker, setComparedTicker, setChartType, comparisonValues } =
    ctx;
  const collapseSection = useBottomControlsSectionCollapse();

  if (!canShowComparison(ctx)) {
    return null;
  }

  const handleChange = (value: string | null) => {
    setComparedTicker(value ?? undefined);
    if (value) {
      setChartType("performance");
    }
    collapseSection();
  };

  return (
    <SelectComparison
      fullWidth={fullWidth}
      value={comparedTicker ?? null}
      values={comparisonValues}
      onChange={handleChange}
    />
  );
};
